import {
  BUYER_DRAFT,
  RESPONDED,
  NEGOTIATION_SENT,
  NEGOTIATION_RESPONDED,
} from 'rfp/bid-manager/main/core/actions/action/status';
import {asSingularOrPlural} from 'rfp/bid-manager/main/core/actions/bid-manager-actions-factory-helpers';
import createBidManagerUploadAction from './create-upload-action';

import UploadNegotiationRequestsDialog from './UploadNegotiationRequestsDialog.svelte';
import ReUploadNegotiationRequestsDialog from './ReUploadNegotiationRequestsDialog.svelte';
import UploadNegotiationResponsesDialog from './UploadNegotiationResponsesDialog.svelte';
import ReUploadNegotiationResponsesDialog from './ReUploadNegotiationResponsesDialog.svelte';


export default {
  uploadRequests,
  reUploadRequests,
  uploadResponses,
  reUploadResponses,
}

const icon = 'drive_folder_upload';

function uploadRequests(actionResultHandler){
  return createBidManagerUploadAction({
    labelFn: report => asSingularOrPlural(report, 'Upload Negotiation Request'),
    icon,
    validStates: [ NEGOTIATION_RESPONDED, RESPONDED, BUYER_DRAFT ],
    dialog: UploadNegotiationRequestsDialog,
    actionResultHandler
  });
}

function reUploadRequests(actionResultHandler){
  return createBidManagerUploadAction({
    labelFn: report => asSingularOrPlural(report, 'Re-upload Negotiation Request'),
    icon,
    validStates: [ NEGOTIATION_SENT ],
    dialog: ReUploadNegotiationRequestsDialog,
    actionResultHandler
  });
}

function uploadResponses(actionResultHandler){
  return createBidManagerUploadAction({
    labelFn: report => asSingularOrPlural(report, 'Upload Negotiation Response'),
    icon,
    validStates: [ NEGOTIATION_SENT ],
    dialog: UploadNegotiationResponsesDialog,
    actionResultHandler
  });
}

function reUploadResponses(actionResultHandler){
  return createBidManagerUploadAction({
    labelFn: report => asSingularOrPlural(report, 'Re-upload Negotiation Response'),
    icon,
    validStates: [ NEGOTIATION_RESPONDED ],
    dialog: ReUploadNegotiationResponsesDialog,
    actionResultHandler
  });
}
